import { ChartRangeSelector } from '@/components/shared/chartRangeSelector'
import { VALID_CHART_PERIODS, useSettingsContext } from '@/context/settings'
import { useBorrowMarketHistoricalQuery } from '@/queries/borrowMarketHistorical.query'
import type { BorrowMarketAssetData } from '@/utils/internalAppSdk'
import type { Network } from '@vaultsfyi/common/types'
import { BorrowMarketDetailsStatsCharts } from './borrowMarketDetailsStatsCharts'

interface Props {
  network: Network
  marketId: string
  borrowAssetData: BorrowMarketAssetData
}

export const BorrowMarketDetailsStats = ({ network, marketId, borrowAssetData }: Props) => {
  const { chartsPeriod, handleChartsPeriod } = useSettingsContext()
  const {
    data: chartData,
    isError: isChartError,
    isFetching: isChartFetching,
  } = useBorrowMarketHistoricalQuery({
    network,
    marketId,
    assetId: borrowAssetData.marketAssetId,
    chartsPeriod,
    enabled: borrowAssetData.supportsHistoricalData,
  })
  const rangeSelector = (
    <div className="flex items-center gap-2 text-sm">
      <span>Chart range</span>
      <ChartRangeSelector
        chartPeriods={VALID_CHART_PERIODS}
        chartsPeriod={chartsPeriod}
        onRangeSelect={handleChartsPeriod}
        className="h-6"
      />
    </div>
  )

  return (
    <BorrowMarketDetailsStatsCharts
      borrowAssetData={borrowAssetData}
      chartData={chartData}
      isChartError={isChartError}
      isChartFetching={isChartFetching}
      rangeSelector={rangeSelector}
    />
  )
}
